<template>
  <div ref="varejopagform">
    <div class="d-flex flex-column" style="gap: 15px">
      <div class="w-100 d-flex" style="gap: 30px">
        <a class="text-secondary cursor-pointer" style="font-size: 12px;" @click="handleRetorna">
          ESC Retornar para Produtos</a>
        <a class="text-secondary cursor-pointer" style="font-size: 12px;"
          v-if="totalPago" @click="handleLimparPag">
          Zerar Pagamentos
        </a>
      </div>
      <!-- INFORMAÇÕES RECEBIMENTOS A ESQUERDA -->
      <div class="border shadow half-card">
        <div
          class="d-flex justify-content-start align-items-center"
          style="gap: 10px; padding: 10px; padding-inline: 2px!important"
        >
          <div
            class="d-flex align-items-start"
            style="gap:30px; padding-top: 2px; align-items: center;"
          >
            <div class="d-flex flex-column">
              <span> Forma de Pagamento</span>
              <input-value
                type="value"
                id="paymentType"
                ref="paymentType"
                class="vd-input d-flex justify-content-start text-left"
                placeholder="Digite o código"
                v-model.number="formaPagamento"
                style="max-width: 200px; max-height: 45px; font-size: 18px!important;"
                @keyenter="handleEnterTypePay()"
              />
            </div>

            <div class="d-flex flex-column">
              <span class="mr-2">Valor do Pagamento</span>
              <div>
                <div class="d-flex justify-content-start align-items-start" style="gap:30px">
                  <input-value
                    @keyenter="handleEnterPaymentValue()"
                    ref="valorpagamento"
                    class="vd-input wr-input--amount-tendered"
                    style="max-width: 200px; max-height: 45px; font-size: 18px!important"
                    :precision="2"
                    v-model="valorPagamento"
                  />
                  <div class="error" style="" v-if="formaPagamento && formaPagamento > fpagList.length">
                      <span>Forma inválida</span>
                  </div>
                  <div class="text-dark" style="" v-if="formaPagamento && formaPagamento <= fpagList.length || listPagamentos.length > 0">
                    <strong class="font-weight-bold">
                      <i :class="formaPagamento ? fpagList[formaPagamento - 1].icon : listPagamentos[listPagamentos.length - 1].fpag.icon"></i>
                      <span class="ml-1">
                        {{ formaPagamento ? fpagList[formaPagamento - 1].descricao : listPagamentos[listPagamentos.length - 1].fpag.descricao }}
                      </span>
                    </strong>
                  </div>


                </div>
                <span class="vd-text-supplementary d-block">{{ titulo }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- lista de pagamentos recebidos -->
        <div class="p-2" v-if="listPagamentos.length > 0">
          <div class="my-2">
            <div v-for="(pag, index) in listPagamentos" :key="index">
              <div class="col-12 my-1">Recebido em {{ pag.fpag.descricao }}
                  {{ pag.parcelas }}x
                <strong class="vd-text-medium float-right">
                  R$ {{ pag.valor | formatValue(2) }}</strong
                >
              </div>
            </div>
          </div>
        </div>

        <!-- FORMAS DE PGTO -->
        <div class="p-2" aria-labelledby="btnGroupDrop1">
          <div class="row">
            <template v-for="(opcao, index) in fpagList">
              <div class="col-3 mb-2" :key="index">
                <div class="nb-dash-card p-2 mx-n2 text-center align-items-center">
                  <span class="w-100">
                    <strong
                      class="bg-light border  rounded-circle text-dark"
                      style="top:3px; left:3px; font-size:11px; padding: 2px 6px; padding-right: 5.5px;">
                      {{ index + 1 }}
                    </strong>
                  </span>
                  <span class="w-100 mt-1">{{ opcao.descricao }}</span>
                </div>
              </div>
              </template>
          </div>
        </div>
      </div>

      <!-- BOTÃO DE PAGAMENTO -->
      <div class="row mx-0 px-0 mt-2 mb-2" v-if="totalPago >= params.totalVenda">
        <div v-if="!confirmPag" class="col-12 mb-2">
          <button
            class="btn font-weight-bold w-100" ref="btnconfirmpag" :style="hasBgButtomconfig()" @click="handleConfirmPag()">
            <span style="font-size:15px; text-transform: uppercase;">Finalizar Recebimento (ENTER)</span>
            <span class="spinner-border ml-2" role="status" style="height:15px; width:15px" v-if="loadbutton"></span>
          </button>
        </div>
        <div v-if="confirmPag" class="col-8 mb-2">
          <button
            class="btn font-weight-bold w-100"
            id="btnPaymentDone"
            ref="btnPaymentDone"
            :style="hasBgButtomconfig()"
            :disabled="totalPago < params.totalVenda"
            @keydown.120="showModalDocumentos=true"
            @click="handleDonePayment"
          >
            <span style="font-size:15px; text-transform: uppercase;">
            {{
              params_pdv.default_focus_btn_pag == "CP"
                ? "Imprimir Cupom (ENTER)"
                : params_pdv.default_focus_btn_pag == "ES"
                ? "Emitir Sat (ENTER)"
                : params_pdv.default_focus_btn_pag == "NC"
                ? "Emitir NFC-e (ENTER)"
                : params_pdv.default_focus_btn_pag == "NF"
                ? "Emitir NF (ENTER)"
                : "Finalizar Venda (ENTER)"
            }}
            </span>
          </button>
        </div>
        <div class="col-4 mb-2" v-if="confirmPag">
          <button
            class="btn btn-outline-secondary font-weight-bold w-100" @click="showModalDocumentos=true"
            @keydown.120="showModalDocumentos=true">
            <span style="font-size:15px;">(F9) Mais Opções</span>
          </button>
        </div>

        <!-- <div class="col-4 p-1" v-if="confirmPag && params_pdv.default_focus_btn_pag != 'NC'">
          <button
            class="btn btn-green font-weight-bold w-100" v-if="confirmPag" @click="handleDocument('NC')">
            <span style="font-size:15px; text-transform: uppercase;">NF Consumidor</span>
          </button>
        </div>
        <div class="col-4 p-1" v-if="confirmPag && params_pdv.default_focus_btn_pag != 'NF'">
          <button
            class="btn btn-orange font-weight-bold w-100"  v-if="confirmPag" @click="handleDocument('NF')">
            <span style="font-size:15px; text-transform: uppercase;">Emitir NF</span>
          </button>
        </div>
        <div class="col-4 p-1" v-if="confirmPag && params_pdv.default_focus_btn_pag != 'CP'">
          <button
            class="btn btn-blue font-weight-bold w-100"  v-if="confirmPag" @click="handleDocument('CP')">
            <span style="font-size:15px; text-transform: uppercase;">Cupom Não Fiscal</span>
          </button>
        </div>
        <div class="col-4 p-1" v-if="confirmPag && params_pdv.default_focus_btn_pag != 'FV'">
          <button
            class="btn btn-red font-weight-bold w-100"  v-if="confirmPag" @click="showModalDocumentos=true">
            <span style="font-size:15px; text-transform: uppercase;">Finalizar Venda</span>
          </button>
        </div> -->
      </div>

<!-- total da venda e valor pago -->
      <div v-if="saldo > 0"
        class="shadow half-card"
        :style="
          saldo <= 0
            ? 'background-color: white'
            : `background-color: white; color: #343a40 !important; padding: 11px;border-radius:5px; font-weight: 500; font-size: 1.25rem;`
        "
      >
        <div class="">
          <div class="col-md-12" v-if="enableCreditoLoja">
            <span class="vd-text-medium">Saldo em Crédito na Loja</span>
            <strong class="vd-text-medium float-right">
              (R$ {{ creditoLoja.saldo | formatValue(2,true) }})</strong>
          </div>
        </div>
        <div class="">
          <div class="col-md-12" v-if="saldo > 0">
            <span class="vd-text-medium">SALDO A RECEBER</span>
            <strong class="vd-text-medium float-right">
              R$ {{ saldo | formatValue(2,true) }}</strong>
          </div>
        </div>
        <div class="col-md-12" v-if="saldo > 0">
          <strong class="vd-text-medium">VALOR RECEBIDO</strong>
          <strong class="vd-text-medium float-right" v-if="totalPago > 0">
            R$ {{ totalPago | formatValue(2,true) }} </strong>
          <strong class="vd-text-medium float-right" v-else>
            R$ {{ 0 | formatValue(2,true) }} </strong>
        </div>
        <!-- <div class="col-md-12" v-if="saldo < 0">
          <strong class="vd-text-medium text-success">TROCO</strong>
          <strong class="vd-text-medium text-success float-right">{{ this.saldo ? this.saldo * -1 : 0 | formatValue(2,true) }}</strong>
        </div> -->
      </div>

      <div class="shadow" v-if="saldo <= 0"
        :style="`${hasBgconfig(true)}; padding: 11px;border-radius:5px; font-weight: 500; font-size: 1.25rem`">
        <div class="d-flex justify-content-between">
          <span>Total Recebido</span>
          <span>R$ {{ totalPago | formatValue(2,true) }}</span>
        </div>
        <div class="w100"></div>
        <div class="d-flex justify-content-between">
          <span>Troco</span>
          <span>R$ {{ this.saldo ? this.saldo * -1 : 0 | formatValue(2,true) }}</span>
        </div>
      </div>

      <div class="shadow half-card" style="padding: 11px;border-radius:5px;" v-if="pedv">
        <div
          class="d-flex flex-column justify-content-start align-items-start"
          style="gap: 10px"
        >
          <span> <strong style="font-size:12px">Obervaçoes</strong></span>
          <div class="w-100">
            <textarea
              type="text"
              v-model="pedv.obspedido"
              ref="obspedido_side"
              style="font-size:0.950rem; resize: none"
              class="form-control"
              rows="3"
            />
          </div>
        </div>
      </div>

      <!-- <div class="col-md-6 col-12 border shadow rounded-top">
        <div class="row">
          <div
            class="col-12 p-2 text-center vd-text-grand rounded-top"
            :style="hasBgTopButtonconfig()"
          >
            <strong>RESUMO DO PAGAMENTO</strong>
          </div>
        </div>
        <div class="row" v-for="(pag, index) in listPagamentos" :key="index">
          <div class="col-12">
            <strong class="vd-text-grand">{{ pag.fpag.descricao }}</strong>
            <strong class="vd-text-grand" v-if="pag.parcelas > 0">
              {{ pag.parcelas }}x
            </strong>
            <strong class="vd-text-grand float-right">
              {{ pag.valor | formatValue(2) }}</strong
            >
          </div>
        </div>
        <hr />
        <div
          class="d-flex flex-column justify-content-center "
          v-if="totalPago"
        >
          <div class="d-flex align-items-center justify-content-between">
            <strong class="vd-text-grand d-flex">VALOR PAGO</strong>
            <strong class="ml-2 vd-text-grand d-flex">{{
              totalPago | formatValue(2)
            }}</strong>
          </div>
        </div>
      </div> -->

      <div>
        <Trap>
          <VarejoModalOpcoesFinal
            v-if="showModalDocumentos"
            @selected="handleDocument"
            @closeModal="handleRetorna"
          />
        </Trap>
      </div>

    </div>

    <!-- <div class="row p-3">
      <div class="col-12 border shadow rounded-top">
        <div class="row">
          <div class="col-12">
            <strong>FORMAS DE PAGAMENTO</strong>
          </div>
          <div
            class="ml-2 p-0 "
            v-for="(opcao, index) in fpagList"
            aria-labelledby="btnGroupDrop1"
          >
            <span
              :key="index"
              class="text-dark forma-pagamento-list pl-4 py-1 position-relative "
              style="padding-left:30px!important; display:flex!important; "
            >
              <strong
                class="position-absolute translate-middle bg-light border  rounded-circle text-dark"
                :style="
                  `top:3px; left:3px; font-size:11px; padding: 2px 6px; padding-right: 5.5px;`
                "
                >{{ index + 1 }}</strong
              >
              <strong style="word-break: break-all!important">{{
                opcao.descricao
              }}</strong>
            </span>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="row px-3 pb-5" v-if="pedv.obspedido">
      <div class="col-12 border shadow rounded-top">
        <div class="row">
          <div class="col-12">
            <strong>OBSERVAÇÕES</strong>
          </div>

          <div class="ml-2 p-0 vd-text-grand">
            <span style="word-break: break-all!important">{{
              pedv.obspedido
            }}</span>
          </div>
        </div>
      </div>
    </div> -->

    <!-- FORM DE DIGITACAO DAS PARCELAS DO PAGAMENTO EM CARTAO DE CREDITO, BOLETO, CHEQUE -->
    <div v-if="showParcelas">
      <varejo-parcelas-form
        :params_pdv="params_pdv"
        :eventAlt="eventAlt"
        :params="paramParcelas"
        @cancel="cancelFormParcelas"
        @confirma="handleConfirmaParcelas"
      ></varejo-parcelas-form>
    </div>
  </div>
</template>

<script>
import { formatValue, isValidHashColor } from "../shared/utils";
import { apiORDS } from "../shared/api-functions";
import VarejoParcelasForm from "./varejo-parcelas-form";
import CpfValidate from "../shared/cpf";
import VarejoModalOpcoesFinal from "./varejo-modal-opcoes-final";
import Trap from "vue-focus-lock";

export default {
  props: {
    params: {},
    params_pdv: {},
    selectedPart: {}
  },

  data() {
    return {
      eventAlt: "",
      listPagamentos: [], //LISTA DE PAGAMENTOS SELECIONADOS,
      formaPagamento: "",

      totalPago: 0, //TOTAL PAGO BASEADO NOS PAGAMENTOS SELECIONADOS
      saldoPagar: 0,
      saldo: 0,
      valorPagamento: 0,
      inFocusVlrPag: false,
      confirmPag: false,
      loadbutton: false,

      email: "",
      pedv: null,

      codpart: null,
      enableCreditoLoja: false, //HABILITA BOTAO "CREDITO LOJA"
      creditoLoja: { saldo: null, codfpag: null },

      pagamentoFinalizado: false,

      selectedFormaPagamento: {}, //forma de pagamento selecionada
      valorCash: 0,

      showParcelas: false, //exibe parcelas quando for selecionado pagamento em ch, boleto, cartao
      paramParcelas: {},

      dadosParcela: {
        dias: 0,
        data: "",
        valor: 0,
        banco: "",
        documento: ""
      },

      listParcelas: [], //array com parcelas e dados dos cheques

      botoesPagamentoEnabled: true, //botoes de pagamento habilitados

      // fpagList: [],

      sat: null,

      showModalDocumentos: false,
    };
  },

  computed: {
    changeCurrency: function() {
      let trocoTotal = 0;
      this.listPagamentos.map(e => {
        trocoTotal = trocoTotal + e.troco;
      });
    },
    fpagList: function() {
      let paglist = this.$store.getters.getFpagList;
      var self = this;
      for (var i = 0; i < paglist.length; i++) {
        paglist[i].descricao = paglist[i].descricao.toUpperCase();
        paglist[i].atalho = "Alt + " + (i + 1) + "";
        let cod = paglist[i].formapag;
        paglist[i].fpagText = "";
        this.metadata.fpag.formapag.options.map(e => {
          if (paglist[i].formapag == e.id) {
            paglist[i].fpagText = e.text;
          }
        });
        switch (cod) {
          case "15":
            paglist[i].icon = "fa fa-barcode";
            break;
          case "03":
            paglist[i].icon = "fa fa-credit-card";
            break;
          case "04":
            paglist[i].icon = "fa fa-credit-card-alt";
            break;
          case "02":
            paglist[i].icon = "fa fa-credit-card";
            break;
          case "05":
            paglist[i].icon = "fa fa-shopping-bag";
            break;
          case "16":
            paglist[i].icon = "fa fa-plus";
            break;
          case "01":
            paglist[i].icon = "fa fa-money";
            break;
          case "17":
            paglist[i].icon = "fa fa-dollar";
            break;
          case "18":
            paglist[i].icon = "fa fa-exchange";
            break;
          case "11":
            paglist[i].icon = "fa fa-shopping-basket";
            break;
          case "19":
            paglist[i].icon = "fa fa-handshake";
            break;
          case "10":
            paglist[i].icon = "fa fa-dollar";
            break;
          case "13":
            paglist[i].icon = "fa fa-dollar";
            break;
          case "12":
            paglist[i].icon = "fa fa-dollar";
            break;
        }
      }
      return paglist;
    },

    part: function() {
      if (this.$store.getters.getPart.length > 0) {
        return this.$store.getters.getPart[0];
      } else {
        return null;
      }
    },

    metadata: function() {
      return this.$store.getters.getEntities.metadata;
    },

    titulo: function() {
      if (this.saldoPagar < 0) {
        return "Troco: " + formatValue(this.saldoPagar * -1, 2);
      } else if (this.saldoPagar > 0) {
        return formatValue(this.saldoPagar, 2) + " a Pagar";
      } else {
        return "Informe o valor para pagamento";
      }
    }
  },

  watch: {
    totalPago: function() {
      this.saldo = this.params.totalVenda - this.totalPago;
    },

    valorPagamento: function() {
      //CALCULA O SALDO A PAGAR
      this.saldoPagar =
        this.params.totalVenda - this.totalPago - this.valorPagamento;
    }
  },

  filters: {},

  methods: {
    hasBgButtomconfig() {
      if (this.params_pdv && this.params_pdv.colors) {
        return `background-color: ${
          isValidHashColor(this.params_pdv.colors.bg_buttom)
            ? this.params_pdv.colors.bg_buttom
            : "#174b79"
        }; color:${
          isValidHashColor(this.params_pdv.colors.fc_buttom)
            ? this.params_pdv.colors.fc_buttom
            : "write;"
        }!important;`;
      }
    },
    hasBgconfig(onlyBgOption) {
      if (this.params_pdv) {
        if (onlyBgOption) {
          return `background-color: ${
            this.params_pdv.colors.bg_top_bottom
              ? this.params_pdv.colors.bg_top_bottom
              : "#174b79"
          }; color:${
            this.params_pdv.colors.fc_top_bottom
              ? this.params_pdv.colors.fc_top_bottom
              : "white;"
          }!important;`;
        } else {
          return `background-color: ${
            this.params_pdv.colors.bg_top_bottom
              ? this.params_pdv.colors.bg_top_bottom
              : "#174b79"
          }; color:${
            this.params_pdv.colors.fc_top_bottom
              ? this.params_pdv.colors.fc_top_bottom
              : "white;"
          }!important; border-bottom: 1px solid #e9e5e5; height: 30px;`;
        }
      } else {
        return "background-color: #174b79; color: white; border-bottom: 1px solid #e9e5e5; height: 55px;";
      }
    },
    hasBgTopButtonconfig() {
      if (this.params_pdv && this.params_pdv.colors) {
        return `background:${
          isValidHashColor(this.params_pdv.colors.bg_top_bottom)
            ? this.params_pdv.colors.bg_top_bottom
            : "#174b79"
        }; color:${
          isValidHashColor(this.params_pdv.colors.fc_top_bottom)
            ? this.params_pdv.colors.fc_top_bottom
            : "white;"
        }`;
      } else {
        return "background: #174b79; color: white;";
      }
    },

    handleDescontoAcrescimo() {
      this.$emit("showModalDesconto");
    },

    handleCliente() {
      this.$emit("showModalCliente", true);
    },

    handleLimparPag() {
      this.totalPago = 0;
      this.saldo = this.params.totalVenda - this.totalPago;
      this.valorPagamento = this.params.totalVenda;
      this.saldoPagar = this.params.totalVenda;
      this.listPagamentos = []; //LISTA DE PAGAMENTOS SELECIONADOS,
      this.formaPagamento = "";
      this.$nextTick(function() {
        this.$refs.paymentType.focus();
      });
    },
    handleObs(obspedido) {
      this.pedv.obspedido = obspedido;
      this.handleRetorna();
    },
    handleClickNFe() {
      var self = this;
      if (
        !this.selectedPart ||
        !this.selectedPart.codpart ||
        (this.selectedPart.codpart && this.selectedPart.cnpjcpf == "CONSUMIDOR")
      ) {
        this.selectedPart = null;
        this.codpart = null;

        if (this.$refs.part) {
          this.$nextTick(function() {
            this.$refs.part.focus();
          });
        }
        this.$erpToastError(
          "Para gerar a nota fiscal o cliente deve ser informado."
        );
      } else {
        this.$emit(
          "resultadopagamento",
          this.listPagamentos,
          this.selectedPart,
          this.email,
          "NFe"
        );
      }
    },
    handleConfirmPag() {
      let self = this;
      this.loadbutton = true;
      this.confirmPag = true;
      this.$nextTick(function() {
        this.$refs.btnPaymentDone.focus();
      });
    },
    handleDocument(value) {
      console.log(value)
      switch (value) {
        case "CP":
          this.handleClickPrint();
          break;
        case "ES":
          this.handleClickSAT();
          break;
        case "NC":
          this.handleClickNFCe();
          break;
        case "NF":
          this.handleClickNFe();
          break;
        case "FV":
          this.handleFinalizaVenda();
          break;
      }
    },
    handleDonePayment() {
      var self = this;

      this.showModalDocumentos = false;

      if (this.params_pdv.default_focus_btn_pag) {
        switch (this.params_pdv.default_focus_btn_pag) {
          case "CP":
            this.handleClickPrint();
            break;
          case "ES":
            this.handleClickSAT();
            break;
          case "NC":
            this.handleClickNFCe();
            break;
          case "NF":
            this.handleClickNFe();
            break;
          case "FV":
            this.handleFinalizaVenda();
            break;
        }
        return;
      } else {
        this.handleFinalizaVenda();
        return;
      }
    },
    handleEnterTypePay() {
      if (this.formaPagamento && this.formaPagamento > this.fpagList.length) {
        this.$nextTick(function() {
          this.$refs.paymentType.focus();
        });
        return
      }
      if (this.formaPagamento) {
        this.$nextTick(function() {
          this.$refs.valorpagamento.focus();
        });
      } 
      else {
        this.$nextTick(function() {
          this.$refs.paymentType.focus();
        });
      }
    },
    handleEnterPaymentValue() {
      let forma = this.formaPagamento - 1;

      this.fpagList.map((e, i) => {
        if (forma == i) {
          this.handleClickFormaPagamento(i);
          return;
        }
      });
      this.formaPagamento = "";

      if (this.totalPago >= this.params.totalVenda) {
        this.$nextTick(function() {
          this.$refs.btnconfirmpag.focus();
        });
      } else 
      if (!this.showParcelas) {
        this.$nextTick(function() {
          this.$refs.paymentType.focus();
        });
      }
    },

    async loadCreditoLoja(selectedPart) {
      // CARREGA O SALDO EM CREDITO DO CLIENTE SELECIONADO
      this.enableCreditoLoja = false;
      this.creditoLoja.saldo = null;

      let pagCredito = 0
      this.listPagamentos.forEach((pag, index) => {
        if (pag.fpag.codfpag == this.creditoLoja.codfpag)
          pagCredito += pag.valor
      })
      if (pagCredito > 0) {
        this.handleLimparPag()
      }

      if (!selectedPart || !selectedPart.codpart) 
        return;

      let self = this;
      let url =  this.$store.getters.urlOrds + "varejo/creditoloja/" + selectedPart.codpart;
      apiORDS(url, {}).then(result => {
        if (result.creditoloja) {
          // self.$set(self.selectedPart, "creditoLoja", result.creditoloja);
          self.creditoLoja.saldo = result.creditoloja
          self.creditoLoja.codfpag = result.codfpag;
          self.enableCreditoLoja = true;
          self.handleClickCredito()
        } else {
          self.creditoLoja.saldo = null;
          self.enableCreditoLoja = false;
        }
      });
    },

    handleClickPrint() {
      this.$emit(
        "resultadopagamento",
        this.listPagamentos,
        this.selectedPart,
        this.email,
        "PRINT"
      );
    },

    handleClickNFCe() {
      this.$emit(
        "resultadopagamento",
        this.listPagamentos,
        this.selectedPart,
        this.email,
        "NFCe"
      );
    },

    handleRetorna(event) {
      //BOTAO RETORNAR PARA VENDA
      if (this.showParcelas) {
        this.cancelFormParcelas();
        return;
      }
      if (this.showModalDocumentos) {
        this.showModalDocumentos = false;
        this.$nextTick(function() {
          this.$refs.btnPaymentDone.focus();
        });
        return;
      }
      if (!this.showDocs && !this.showParcelas) {
        this.$emit(
          "resultadopagamento",
          null,
          this.selectedPart,
          this.email,
          "RETORNAVENDA"
        );
        return;
      }

      if (this.pagamentoFinalizado) {
        this.pagamentoFinalizado = false;
        this.$nextTick(function() {
          this.$refs.paymentType.focus();
        });
        return;
      }
    },

    handleEnterValorCash() {
      //ENTER NO CAMPO DE VALOR EM DINHEIRO
    },

    handleClickValoresCash(index) {
      //CLICK NOS VALORES DO PAGAMENTO EM DINHEIRO
    },

    cancelFormParcelas() {
      //CANCELAMENTO NO FORM DE PARCELAS
      this.selectedFormaPagamento = null;
      this.showParcelas = false;
      this.$nextTick(function() {
        this.$refs.paymentType.focus();
      });
    },

    handleClickSAT() {
      /*


      PARA CANCELAMENTO DO SAT:
      - CHAMAR A EXTENSAO ENVIANDO O XML DO SAT

      */
      this.$emit(
        "resultadopagamento",
        this.listPagamentos,
        this.selectedPart,
        this.email,
        "SAT"
      );

      //this.sat = { message: 'Enviando...' }
      //let XMLSAT = '<CFe><ide><signAC>SGR-SAT SISTEMA DE GESTAO E RETAGUARDA DO SAT</signAC><codigoDeAtivacao>12345678</codigoDeAtivacao><modSAT>2</modSAT><nomeDLL>C:\NB\SAT\SAT.dll</nomeDLL><numeroCaixa>1</numeroCaixa><swCNPJ>16716114000172</swCNPJ><emitCNPJ>08723218000186</emitCNPJ><emitIE>149626224113</emitIE><emitIM></emitIM><regTrib>0</regTrib><regTribISSQN></regTribISSQN><indRatISSQN>N</indRatISSQN><tpAmb>2</tpAmb><cNF>10</cNF></ide><dest><CNPJCPF>05481336000137</CNPJCPF><xNome>Empresa de Teste</xNome><entrega><xLgr></xLgr><nro></nro><xCpl></xCpl><xBairro></xBairro><xMun></xMun><UF></UF></entrega></dest><item><det nItem="1"><cProd>ACBR0001</cProd><cEAN>6291041500213</cEAN><xProd>Assinatura SAC</xProd><NCM>99</NCM><CFOP>5120</CFOP><uCom>UN</uCom><qCom>1.0000</qCom><vUnCom>10.00</vUnCom><indRegra>A</indRegra><vItem>10.00</vItem><orig>0</orig><ICMS><sitTrib>102</sitTrib></ICMS><PIS><sitTrib>49</sitTrib></PIS><COFINS><sitTrib>49</sitTrib></COFINS></det><det nItem="2"><cProd>6291041500213</cProd><cEAN>6291041500213</cEAN><xProd>Outro produto Qualquer, com a Descricao Grande</xProd><CFOP>5529</CFOP><uCom>un</uCom><qCom>1.0000</qCom><vUnCom>100.00</vUnCom><indRegra>A</indRegra><ICMS><sitTrib>102</sitTrib></ICMS><PIS><sitTrib>49</sitTrib></PIS><COFINS><sitTrib>49</sitTrib></COFINS></det></item><total></total><pgto><MP><cMP>03</cMP><vMP>10.00</vMP></MP><MP><cMP>01</cMP><vMP>100.00</vMP></MP></pgto></CFe>'
      //this.$SATExtension(XMLSAT, this.SATCallBack)
    },

    SATCallBack(response) {
      //CALLBACK QUANDO O SAT É ENVIADO

      this.$appLoading(false);
      if (response.xml) {
        //FALTA CARREGAR O XML DO SAT RECEBIDO PARA GRAVAR NA TABELA DE VENDA
        //CHAMAR API PARA GRAVAR SAT
      }

      this.sat = response;

      // this.errmessages = {}
      // if (response.status != 'success') {
      //     this.$erpToastError(response.message)
      // } else {
      //     if (response.response.nf.length > 0 && response.response.nf[0].cstat == '100') {
      //         this.$erpToastSuccess(response.message)
      //     }
      //     else {
      //         this.$erpToastError(response.response.nf[0].xmotivo)
      //     }
      // }
      // this.loadData()
    },

    handleClickCredito() {
      //UTILIZAR CREDITO LOJA

      if (this.creditoLoja.saldo > 0) {
        this.$erpToastWarning("Este cliente possui saldo em crédito!");
      } else {
        return
      }

      let idx = null
      this.fpagList.forEach((pag, index) => {
        if (pag.codfpag == this.creditoLoja.codfpag)
          idx = index
      })

      if (!idx) {
        this.$erpToastError("Erro: Cadastre uma forma de pagamento Crédito Loja!");
        return;
      }

      this.valorPagamento = 0;
      this.saldoPagar = this.params.totalVenda - this.totalPago;
      if (this.creditoLoja.saldo < this.saldoPagar) {
        this.valorPagamento = this.creditoLoja.saldo;
      } else {
        this.valorPagamento = this.saldoPagar;
      }

      this.saldoPagar = this.params.totalVenda - this.totalPago - this.valorPagamento;
      
      this.handleClickFormaPagamento(idx)

//       let pagamento = {
//         valor: this.valorPagamento,
//         troco: 0,
//         fpag: this.selectedFormaPagamento,
//         listParcelas: null
//       };

//       this.listPagamentos.push(pagamento);
//       this.totalPago = parseFloat(this.totalPago) + parseFloat(this.valorPagamento);
//       this.saldo = this.params.totalVenda - this.totalPago;
//       this.valorPagamento = 0;
//       this.saldoPagar = this.params.totalVenda - this.totalPago - this.valorPagamento;

//       if (this.saldoPagar <= 0) {
//         this.pagamentoFinalizado = true;
//       }
    },

    handleFinalizaVenda() {
      //retorna os dados do pagamento para o objeto pai
      //emite o evento "finaliza"
      this.$emit(
        "resultadopagamento",
        this.listPagamentos,
        this.selectedPart,
        this.email,
        "OK"
      );
    },

    handleClickFormaPagamento(index) {
      //BOTAO PAGAR, AO SELECIONAR UMA FORMA DE PAGAMENTO
      if (this.valorPagamento > 0) {
        //ADICIONA UMA FORMA DE PAGAMENTO
        this.selectedFormaPagamento = this.fpagList[index];

        //BOLETO, CHEQUE OU CARTAO CREDITO SELECIONADO
        if (
          this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.cheque ||
          this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.boleto ||
          this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.credito
        ) {
          this.showDigitacaoParcelas();
          return;
        }

        let troco = 0;

        if (this.saldoPagar < 0) {
          if (this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.dinheiro) {
            troco = this.saldoPagar * -1;
          } else {
            this.$erpToastWarning("O valor informado não é permitido");
            return;
          }
        }

        //valida o saldo em credito
        if (this.selectedFormaPagamento.formapag == this.params.paramscaixa.tpag.creditoloja) {
          if (this.enableCreditoLoja && this.creditoLoja.saldo > 0) {
            let pagCredito = 0
            this.listPagamentos.forEach((pag, index) => {
              if (pag.fpag.codfpag == this.creditoLoja.codfpag)
                pagCredito += pag.valor
            })
            if (pagCredito + this.valorPagamento > this.creditoLoja.saldo) {
              this.$erpToastWarning("O valor informado é superior ao saldo do cliente");
              return
            }
          } 
          else {
            this.$erpToastWarning("Forma de pagamento não permitida para clientes sem saldo em crédito");
            return
          }
        }

        //
        let pagamento = {
          valor: this.valorPagamento,
          troco: troco,
          fpag: this.selectedFormaPagamento,
          listParcelas: null
        };

        this.listPagamentos.push(pagamento);

        this.totalPago =
          parseFloat(this.totalPago) + parseFloat(this.valorPagamento);

        this.saldo = this.params.totalVenda - this.totalPago;
        this.valorPagamento = this.saldo
      }
      if (this.saldoPagar <= 0) {
        this.pagamentoFinalizado = true;
        this.handleSetFocusBtn();
      } else {
        this.valorPagamento = this.saldoPagar;
        this.$refs.paymentType.focus();
      }

      //SETANDO FOCO PARA BTN DEFAULT
      // if ((!this.selectedPart) || (!this.selectedPart.codpart) || (this.selectedPart.codpart && this.selectedPart.cnpjcpf == 'CONSUMIDOR')){
      //     this.selectedPart = null
      //     this.codpart = null
      //     this.$nextTick(function () {
      //         this.$refs.part.focus()
      //     })
      // }
    },
    handleSetFocusBtn() {
      this.$nextTick(() => {
        if (this.params_pdv.default_focus_btn_pag == "CP") {
          if (this.$refs.CP) {
            this.$refs.CP.focus();
          }
        }
        if (this.params_pdv.default_focus_btn_pag == "ES") {
          if (this.$refs.ES) {
            this.$refs.ES.focus();
          }
        }
        if (this.params_pdv.default_focus_btn_pag == "NC") {
          if (this.$refs.NC) {
            this.$refs.NC.focus();
          }
        }
        if (this.params_pdv.default_focus_btn_pag == "NF") {
          if (this.$refs.NF) {
            this.$refs.NF.focus();
          }
        }
        if (this.params_pdv.default_focus_btn_pag == "FV") {
          if (this.$refs.FV) {
            this.$refs.FV.focus();
          }
        }
      });
    },

    showDigitacaoParcelas() {
      //MONTA OS PARAMETROS PARA DIGITACAO DAS PARCELAS
      this.paramParcelas = {
        parcelas: 1,
        valorPagamento: this.valorPagamento,
        cheque:
          this.selectedFormaPagamento.formapag ==
          this.params.paramscaixa.tpag.cheque,
        cartaoCredito:
          this.selectedFormaPagamento.formapag ==
          this.params.paramscaixa.tpag.credito,
        boleto:
          this.selectedFormaPagamento.formapag ==
          this.params.paramscaixa.tpag.boleto,
        paramscaixa: this.params.paramscaixa
      };
      //EXIBE A DIGITACAO DAS PARCELAS
      this.showParcelas = true;
    },

    handleConfirmaParcelas(parcelas, listParcelas) {
      //CONFIRMACAO DAS PARCELAS DAS VENDAS EM BOLETO, CHEQUE OU CARTAO
      //ADICIONA A FORMA DE PAGAMENTO E SUAS PARCELAS NA LISTA DE PAGAMENTOS EFETUADOS
      this.showParcelas = false;

      let pagamento = {
        valor: this.valorPagamento,
        troco: 0,
        fpag: this.selectedFormaPagamento,
        listParcelas: listParcelas,
        parcelas: listParcelas.length
      };

      this.listPagamentos.push(pagamento);

      this.totalPago =
        parseFloat(this.totalPago) + parseFloat(this.valorPagamento);

      this.saldo = this.params.totalVenda - this.totalPago;

      //SE O SALDO A PAGAR FOR 0, FINALIZA A VENDA
      if (this.saldoPagar == 0) {
        this.pagamentoFinalizado = true;
        this.$nextTick(function() {
          this.$refs.btnconfirmpag.focus();
        });
      } else {
        if (this.saldoPagar > 0) this.valorPagamento = this.saldoPagar;
        this.$refs.paymentType.focus();
      }
    },

    calculaParcelas() {
      //CALCULA PARCELAS DO PEDIDO
      this.pedvpar = [];
      let vlr = 0;
      if (this.pedv.parcelas == "0") {
        let parcela = { ...this.$store.getters.getEntities.pedvpar };
        parcela.dtv = this.pedv.data;
        parcela.vlr = this.pedv.totger;
        parcela.obspar = "";
        parcela.dias = 0;
        this.pedvpar.push(parcela);
      } else {
        for (var x = 1; x <= this.pedv.parcelas; x++) {
          let parcela = { ...this.$store.getters.getEntities.pedvpar };
          parcela.dtv = this.$addMonths(this.pedv.data, x);
          parcela.dias = x * 30;
          vlr = this.pedv.totger;
          vlr = arr(vlr / this.pedv.parcelas, 2, true);
          parcela.vlr = vlr;
          parcela.obspar = "";
          this.pedvpar.push(parcela);
        }
      }
      this.$nextTick(function() {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    },

    parcelasVlrChange(index) {
      //evento de controle de alteracao do valor da parcela
      //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
      if (this.pedv.parcelas <= 1) {
        return;
      }
      let vlrparcial = 0;
      let vlrnovaparcela = 0;
      for (var x = 0; x <= index; x++) {
        vlrparcial = vlrparcial + parseFloat(this.pedvpar[x].vlr);
      }
      if (vlrparcial < this.pedv.totger) {
        vlrnovaparcela =
          (this.pedv.totger - vlrparcial) / (this.pedv.parcelas - (index + 1));
        vlrnovaparcela.toFixed(2);
      } else {
      }
      for (var x = index + 1; x <= this.pedvpar.length - 1; x++) {
        this.pedvpar[x].vlr = vlrnovaparcela;
      }
    },

    parcelasDiasChange(index) {
      //evento de controle de alteracao do nr de dias de vencimento da parcela
      this.pedvpar[index].dtv = this.$addDays(
        this.pedv.data,
        this.pedvpar[index].dias
      );
    },

    parcelasBancoChange(index) {},

    async loadData() {
      //await this.$store.dispatch('loadItemSales', { codtabpre: this.priceTab, filter: this.filter })
    }
  },

  components: {
    VarejoParcelasForm,
    VarejoModalOpcoesFinal,
    Trap
  },

  created() {
  },
  
  destroyed() {
    clearInterval();
  },

  mounted() {
    this.$nextTick(function() {
      //const rect = this.$refs.pesquisa.getBoundingClientRect();
      jQuery('[data-toggle="tooltip"]').tooltip();
        this.$refs.paymentType.focus();
      });

    this.$store.dispatch("loadFpag", { filter: null, page: null });

    this.valorPagamento = this.params.totalVenda;
    this.saldoPagar = this.params.totalVenda;
    this.totalPago = 0;
    this.saldo = this.params.totalVenda - this.totalPago;

    this.codpart = this.params.codpart;
    this.email = this.params.email;
    this.pedv = this.params.pedv;

    this.loadCreditoLoja(this.selectedPart)

  }
};
</script>

<style>
.vd-input {
  cursor: text;
  color: #3a4953;
  font-family: lato, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  font-weight: 400;
  font-size: 15px;
  word-break: normal;
  width: 100%;
  margin: 0;
  padding: 12px;
  box-sizing: border-box;
  outline: none;
  box-shadow: none;
  background-color: #fff;
  border: 2px solid #e5eaed;
  border-radius: 3px;
  transition: all 0.2s;
  transition-property: border-color, box-shadow;
}

.wr-input--amount-tendered {
  max-width: 100%;
  width: 200px;
  height: 60px;
  text-align: right;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  word-break: break-word;
  margin: 0;
  font-size: 32px;
  line-height: 1.5;
  font-weight: 700;
}

.vd-text-supplementary {
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 1.25;
  font-weight: 400;
}

.btn--payment-type {
  position: relative;
  flex-basis: calc(33.333% - 8px);
}

.varejo-button {
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* -moz-font-feature-settings: "liga","kern"; */
  position: relative;
  font-family: lato, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  cursor: pointer;
  font-size: 15px;
  border-radius: 3px;
  padding: 12px 20px;
  text-align: center;
  box-sizing: border-box;
  display: inline-block;
  min-width: 100px;
  margin: 0 4px;
  border: 1px solid transparent;
  font-weight: 700;
  transition: all 0.2s;
  transition-property: background, color, border;
  outline: none;
}

.varejo-button.varejo-button--primary {
  background-color: #41af4b;
  color: #fff;
}

.varejo-button.varejo-button--big {
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* -moz-font-feature-settings: "liga","kern"; */
  line-height: 1.22222;
  font-size: 18px;
  padding: 16px 32px;
}

.varejo-button:last-child {
  margin-right: 0;
}

.varejo-button:first-child {
  margin-left: 0;
}

.varejo-button.varejo-button--primary.disabled,
.varejo-button.varejo-button--primary:disabled,
.varejo-button.varejo-button--primary:disabled:hover,
.varejo-button.varejobutton--primary[disabled] {
  cursor: default;
  pointer-events: none;
  opacity: 0.35;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}

.alert-short {
  border-top: 1px solid #6c757d !important;
}

.wr-info-fields {
  margin-left: -5px;
  margin-right: -5px;
  display: flex;
}

.wr-info-fields--center {
  justify-content: center;
  text-align: center;
}

.wr-info-fields--large {
  justify-content: center;
  text-align: center;
}

.wr-info-fields .wr-info-field {
  padding: 0 5px;
  flex: 1;
}

.wr-info-field {
  display: block;
  min-width: 0;
  word-wrap: break-word;
  margin: 5px 0;
}

.wr-info-field-label {
  color: #3a4953;
  font-size: 14px;
}

.wr-info-field-value {
  font-size: 24px;
}

.f-pag-icon {
  margin: 1.3rem 0;
}

.f-pag-icon i {
  font-size: 1.5rem;
}

.f-pag-icon span {
  width: 5rem !important;
  height: 1rem !important;
  font-size: 0.65rem;
  font-weight: 900 !important;
  margin-top: -10px !important;
  margin-right: -7px !important;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.f-pag-desc .text-secondary {
  font-size: 13px;
  text-transform: uppercase;
  margin-top: 0.5rem;
}

.f-pag-desc .lbl-list {
  font-size: 11px;
  text-transform: uppercase;
}

.f-pag-action button {
  min-width: 5rem !important;
}

.forma-pagamento-list:hover {
  text-decoration: none;
  background: rgb(245, 244, 244);
}

.half-card {
  width: 100%;
  padding: 5px 15px;
  border-radius: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-pag-form.vue